import { connect } from 'react-redux'
import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import * as constants from '../../../constants'
import { LiveList } from '../components'

const mapStateToProps = (state) => {
  const { user } = state.authentication
  const { viewMode, boards, page, rowsPerPage, totalRows, totalPage, search, isFetching } = state.liveList
  const { language } = state.user
  const { socket } = state.api.live
  var liveBoards, archiveBoards, pageNaviText, startRow, endRow
  if (boards) {
    liveBoards = boards.filter((board) => board.status === constants.liveStatus.OPEN)
    archiveBoards = boards.filter((board) => board.status === constants.liveStatus.CLOSE)
  }
  startRow = (page - 1) * rowsPerPage + 1
  endRow = page * rowsPerPage < totalRows ? page * rowsPerPage : totalRows
  pageNaviText = totalRows !== 0 ? startRow + '-' + endRow + ' of ' + totalRows : ''
  return ({
    user,
    socket,
    viewMode,
    boards: liveBoards.concat(archiveBoards),
    page,
    rowsPerPage,
    pageNaviText,
    search,
    totalRows,
    enableNextPage: Boolean(page < totalPage),
    enableBackPage: Boolean(page > 1),
    isFetching,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClickListButton: () => {
      dispatch(actions.liveList.changeViewMode(constants.liveListViewMode.TABLE))
    },
    handleClickGridButton: () => {
      dispatch(actions.liveList.changeViewMode(constants.liveListViewMode.GRID))
    },
    handleChangeText: () => {
    },
    handleClickRight: (page, rowsPerPage, search) => () => {
      dispatch(api.live.selectBoardContext(rowsPerPage, page * rowsPerPage, search))
      dispatch(actions.liveList.nextPage())
    },
    handleClickLeft: (page, rowsPerPage, search) => () => {
      dispatch(api.live.selectBoardContext(rowsPerPage, (page - 2) * rowsPerPage, search))
      dispatch(actions.liveList.backPage())
    },
    handleKeyDown: (rowsPerPage) => (event) => {
      if (event.keyCode === 13){
        dispatch(actions.liveList.clearPageNavigation())
        dispatch(api.live.selectBoardContext(rowsPerPage, 0, event.target.value))
      }
    },
    init: (rowsPerPage) => {
      dispatch(api.live.selectBoardContext(rowsPerPage, 0))
    },
    clear: () => {
      dispatch(actions.liveList.clearPageNavigation())
      dispatch(actions.liveList.clearBoardContext())
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveList)


// WEBPACK FOOTER //
// ./src/Pages/Live/containers/LiveList.js